import { Box, Typography } from '@mui/material';

export default function Manual() {
  return (
    <Box
      sx={{
        mx: 'auto',
        minWidth: { xs: 400, md: 1200 },
        p: 2,
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Box>
        <Typography variant="h2" gutterBottom textAlign={'center'}>
          Εγχειρίδιο Χρήστη
        </Typography>
      </Box>
      <iframe
        src="map_manual_v1.0.pdf"
        title="Εγχειρίδιο Χρήστη"
        width="100%"
        height="100%"
        style={{ border: 'none' }}
      />
    </Box>
  );
}
